import React from "react";
import { BooleanField, classnames } from "@culturehq/components";

import { ApprovedForSocial, LandingPage, Story } from "chq";
import { Trans } from "app/utils";
import CulturePageSelectorModal from "./culture-page/CulturePageSelectorModal";

interface ApproveLandingPageButtonProps {
  approvedContent?: ApprovedForSocial;
  externalState: string;
  landingPages: LandingPage[];
  onUpdateApprovedForSocial: (value: ApprovedForSocial | Story | Record<string, string[]>) => void;
}

const ApproveLandingPageButton: React.FC<ApproveLandingPageButtonProps> = ({
  approvedContent, externalState, landingPages, onUpdateApprovedForSocial
}) => {
  const cmkMarked = (state: string) => externalState === state || externalState === "approved_for_everything";
  const isChecked = cmkMarked("landing_page");

  return (
    <CulturePageSelectorModal
      approvedContent={approvedContent}
      landingPages={landingPages}
      onUpdateApprovedForSocial={onUpdateApprovedForSocial}
    >
      {(onTrigger: any) => (
        <BooleanField
          name="landing_page"
          onChange={onTrigger}
          className={classnames("LandingPage-cmk", { "LandingPage-cmk-marked": cmkMarked("landing_page") })}
          value={isChecked}
        >
          <Trans>Culture Page</Trans>
        </BooleanField>
      )}
    </CulturePageSelectorModal>
  );
};

export default ApproveLandingPageButton;
